<template>
  <div id="page-selects">
    <v-container grid-list-xl fluid>
      <breadcrumbs
        :routelinks="[
          { text: 'Policies', href: '#/policies' },
          { text: 'Create', href: '#', disabled: true }
        ]"
      />
      <v-layout row wrap>
        <v-flex lg8 md8 xs12>
          <v-widget>
            <div slot="widget-content">
              <div v-show="true">
                <submit-form v-if="isVisible === 0" />
                <submit-image v-if="isVisible === 1" />
              </div>
            </div>
          </v-widget>
        </v-flex>
        <v-flex lg4 md4 xs12>
          <policies-info-nav v-on:listChanged="listChanged" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import PoliciesInfoNav from "@/components/policies/PoliciesInfoNav";
import SubmitImage from "@/components/policies/SubmitImage";
import SubmitForm from "@/components/policies/SubmitForm";
import VWidget from "@/components/VWidget";
export default {
  components: {
    PoliciesInfoNav,
    SubmitImage,
    SubmitForm,
    VWidget,
    Breadcrumbs
  },
  data() {
    return {
      isVisible: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    listChanged: function(index) {
      this.isVisible = index;
    }
  }
};
</script>
